import { authApi } from "@RTKQuery/basic";
import authAuthApi from "../auth/auth";
import { IHistoryRecord } from "@interfaces/user/historyRecord";

const balanceAuthApi = authApi.injectEndpoints({
    endpoints: (build) => ({
        balanceReplenishment: build.mutation<
            { pageUrl: string } | { amount: number, wallet: string } | { balance: number },
            { amount?: number, promo_code?: string, transaction_type?: "monobank" | "crypto" }
        >({
            query: (params) => ({
                url: "balance/top_up",
                method: "GET",
                params
            }),
            async onQueryStarted(_, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;

                    if ("balance" in data) {
                        dispatch(authAuthApi.util.updateQueryData("getUser", undefined, (draft) => {
                            draft.balance = data.balance;
                        }))
                    }
                } catch { }
            },
            invalidatesTags: ["HistoryUser"]
        }),
        balanceHistory: build.query<IHistoryRecord[], void>({
            query: () => "balance/history",
            providesTags: ["HistoryUser"]
        })
    }),
    overrideExisting: false,
})

export const {
    useBalanceReplenishmentMutation,
    useBalanceHistoryQuery
} = balanceAuthApi;